import { Fragment } from 'react'

const ProductShell = () => (
  <Fragment>
    <div className="shell-loader" />
    <div className="shell-loader" />
    <div className="shell-loader" />
  </Fragment>
)

export default ProductShell
